// extracted by mini-css-extract-plugin
module.exports = {"button":"_373a3719ba--button--gs5R_","loading":"_373a3719ba--loading--fC43r","spinner":"_373a3719ba--spinner--rWSqM"};